/**
 * Standardized info (toggle) icon button: circled ⓘ, consistent look across the app.
 * Use next to titles or labels to show/hide an explanation.
 */
import React from 'react';
import './InfoIconButton.css';

function InfoIconButton({
  onClick,
  ariaExpanded,
  ariaControls,
  ariaLabel = 'Show explanation',
  ariaLabelExpanded = 'Hide explanation',
  className = '',
  ...rest
}) {
  return (
    <button
      type="button"
      className={`info-icon-btn ${className}`.trim()}
      onClick={onClick}
      aria-expanded={ariaExpanded}
      aria-controls={ariaControls}
      aria-label={ariaExpanded ? ariaLabelExpanded : ariaLabel}
      {...rest}
    >
      <span aria-hidden>ⓘ</span>
    </button>
  );
}

export default InfoIconButton;
